export default {
  fetchLoggedUser: "/users/me",
  userAcceptCookies: "/users/{id}/cookies/",
  claimsPayments: "/cbx-claims/",
  thirdPartyDetailsApi: "/third-parties/{id}/",
  thirdPartiesApi: "/third-parties/",
  createBankingData: "third-parties/{id}/banking-data/",
  updateBankingData: "/banking-data/{id}/",
}
